var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioCall2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Call@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Call",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-phone-actions-voice-mail@24x24",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0679824131,6.18726899 L1.15322891,7.27252708 C1.71745406,7.8368527 2.48276427,8.15389548 3.28076591,8.15389548 C4.07876755,8.15389548 4.84407776,7.8368527 5.40830291,7.27252708 L7.00415829,5.67746515 C7.28631808,5.39534955 7.44483777,5.01269036 7.44483777,4.61368527 C7.44483777,4.21468018 7.28631808,3.83202099 7.00415829,3.5499054 L3.90079098,0.446504908 C3.59388219,0.136593264 3.16773676,-0.025114152 2.73249452,0.00317689658 C2.29725227,0.0314679452 1.89562592,0.246981102 1.63141818,0.594015717 C-1.61783738,5.00961401 0.349222543,9.660257 4.34493966,13.6552063 C8.34065677,17.6501557 12.9904395,19.6180471 17.4059906,16.3687568 C17.7530215,16.1045463 17.9685324,15.7029156 17.9968231,15.2676687 C18.0251139,14.8324218 17.8634082,14.4062718 17.5534999,14.0993598 L14.450943,10.9959593 C14.1688305,10.7137965 13.7861754,10.5552751 13.3871745,10.5552751 C12.9881737,10.5552751 12.6055186,10.7137965 12.323406,10.9959593 L10.7275507,12.5918317 C10.1632311,13.1560629 9.8461917,13.9213813 9.8461917,14.7193915 C9.8461917,15.5174016 10.1632311,16.28272 10.7275507,16.8469512 L11.8249545,17.9443668",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCall2X);
export default __webpack_public_path__ + "static/media/Audio-Call2x.b45c040edd2d3584bc731d77bac9d849.svg";
export { ForwardRef as ReactComponent };